import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import type { NodeVisibility } from '../../../app/api/generated/client';
import { updateNodeVisibility } from '../../../app/api/generated/client';
import { queryKeys } from '../query-keys';

export function useUpdateNodeVisibility(mainPartnerUuid: string): UseMutationResult<void, AxiosError, { nodeUuid: string; newVisibility: NodeVisibility }> {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ nodeUuid, newVisibility }) => {
            await updateNodeVisibility({ path: { mainPartnerUuid, nodeUuid }, body: { visibility: newVisibility } });
        },
        onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.familyTree(mainPartnerUuid) }),
    });
}
